class AQuietKindTheme {
  constructor() {
    this.revealItems = document.querySelectorAll('[data-aqk-reveal]');
    this.mobileBuy = document.querySelector('[data-aqk-mobile-buy]');
    this.purchaseForm = document.querySelector('[data-aqk-purchase-form]');
    this.quantityControls = document.querySelectorAll('[data-aqk-quantity]');
  }

  init() {
    this.initReveal();
    this.initMobileBuy();
    this.initQuantityControls();
  }

  initReveal() {
    if (!this.revealItems.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      this.revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    this.revealItems.forEach((item) => observer.observe(item));
  }

  initMobileBuy() {
    if (!this.mobileBuy || !this.purchaseForm) return;

    this.mobileBuy.removeAttribute('hidden');

    const updateSpacer = () => {
      const height = Math.ceil(this.mobileBuy.getBoundingClientRect().height);
      if (height > 0) document.documentElement.style.setProperty('--aqk-mobile-buy-height', `${height}px`);
    };

    requestAnimationFrame(updateSpacer);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateSpacer).observe(this.mobileBuy);
    } else {
      window.addEventListener('resize', updateSpacer, { passive: true });
    }

    if (!('IntersectionObserver' in window)) {
      this.mobileBuy.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => this.mobileBuy.classList.toggle('is-visible', !entry.isIntersecting),
      { threshold: 0.15 }
    );

    observer.observe(this.purchaseForm);
  }

  initQuantityControls() {
    this.quantityControls.forEach((control) => {
      const input = control.querySelector('input[type="number"]');
      if (!input) return;

      const minusButton = control.querySelector('[data-aqk-quantity-minus]');
      const plusButton = control.querySelector('[data-aqk-quantity-plus]');
      const minimum = Number(input.min) || 1;
      const maximum = input.max === '' ? Infinity : Number(input.max);

      const updateButtonState = () => {
        const value = Number(input.value);
        const hasValidNumber = input.value.trim() !== '' && Number.isFinite(value);

        if (minusButton) minusButton.disabled = !hasValidNumber || value <= minimum;
        if (plusButton) plusButton.disabled = !hasValidNumber || value >= maximum;
      };

      control.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-aqk-quantity-minus], button[data-aqk-quantity-plus]');
        if (!button) return;

        if (!input.checkValidity()) input.value = String(minimum);

        if (button.hasAttribute('data-aqk-quantity-plus')) {
          input.stepUp();
        } else {
          input.stepDown();
        }

        updateButtonState();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('input', updateButtonState);
      input.addEventListener('change', updateButtonState);

      if (input.form) {
        input.form.addEventListener(
          'submit',
          (event) => {
            if (input.checkValidity()) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            input.reportValidity();
          },
          true
        );
      }

      updateButtonState();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new AQuietKindTheme().init());
